import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = { class: "pa-0 body2-text font-weight-regular brg-color-grey-600" };
const _hoisted_2 = {
    key: 0,
    class: "ms-1"
};
const _hoisted_3 = {
    key: 0,
    class: "ms-1"
};
const _hoisted_4 = { class: "pa-0 body2-text font-weight-regular text-black" };
const _hoisted_5 = {
    key: 0,
    class: "ml-1"
};
const _hoisted_6 = { class: "pa-0 body2-text font-weight-regular" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_col = _resolveComponent("v-col");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_row = _resolveComponent("v-row");
    const _component_ChangePickupExpectedAtDialog = _resolveComponent("ChangePickupExpectedAtDialog");
    const _component_v_card = _resolveComponent("v-card");
    const _component_Chip = _resolveComponent("Chip");
    const _component_OrderDetailDeliveryInfoBarogoTooltip = _resolveComponent("OrderDetailDeliveryInfoBarogoTooltip");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_AdjustDeliveryAmountDialog = _resolveComponent("AdjustDeliveryAmountDialog");
    const _component_v_card_actions = _resolveComponent("v-card-actions");
    const _component_AddWorkerSupportAmountDialog = _resolveComponent("AddWorkerSupportAmountDialog");
    return (_openBlock(), _createBlock(_component_v_card, {
        flat: "",
        tile: "",
        class: "pa-0"
    }, {
        default: _withCtx(() => [
            _createCommentVNode(" 배달번호 "),
            (_ctx.policy.isDeliveryIdShow)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t(_ctx.lc + 'delivery_id')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.deliveryId), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" 경과시간 "),
            (_ctx.policy.isElapsedTimeShow)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    "no-gutters": "",
                    class: "mt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'elapsed_time')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.orderedAtElapsedTime), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" 배차시간 "),
            (_ctx.policy.isAllocatedAtShow)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 2,
                    "no-gutters": "",
                    class: "mt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'allocated_time')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.order.allocatedAt, _ctx.dateFormatType.SHORT_TIME)) + " ", 1 /* TEXT */),
                                        (_ctx.policy.isAllocatedAtElapsedTimeShow)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, " [" + _toDisplayString(_ctx.allocatedAtElapsedTimeSuffix) + "] ", 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" 픽업시간 "),
            (_ctx.policy.isPickedUpAtShow)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 3,
                    "no-gutters": "",
                    class: "mt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'pickup_time')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.validateTextWithHypen(_ctx.formatDate(_ctx.order._pickedUpAt, _ctx.dateFormatType.SHORT_TIME))) + " ", 1 /* TEXT */),
                                        (_ctx.policy.isPickedUpAtElapsedTimeShow)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " [" + _toDisplayString(_ctx.pickedUpAtElapsedTimeSuffix) + "] ", 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" 완료시간 "),
            (_ctx.policy.isFinishedAtShow)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 4,
                    "no-gutters": "",
                    class: "mt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'finished_time')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.order.finishedAt, _ctx.dateFormatType.SHORT_TIME)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" 취소시간 "),
            (_ctx.policy.isCanceledAtShow)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 5,
                    "no-gutters": "",
                    class: "mt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'canceled_time')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.order.canceledAt, _ctx.dateFormatType.SHORT_TIME)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" 취소사유 "),
            (_ctx.policy.isCanceledReasonShow)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 6,
                    "no-gutters": "",
                    class: "mt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'canceled_reason')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.canceledReason), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" 픽업예상시간 "),
            (_ctx.policy.isPickupExpectedAtShow)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 7,
                    "no-gutters": "",
                    class: "mt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'expect_pickup_at')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                    flat: "",
                                    tile: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.order.pickupExpectedAt, _ctx.dateFormatType.SHORT_TIME)) + " ", 1 /* TEXT */),
                                            (_ctx.policy.isPickupExpectedAtRemainingTimeShow)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " [" + _toDisplayString(_ctx.pickupExpectedAtRemainingTimeSuffix) + "] ", 1 /* TEXT */))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _createCommentVNode(" 시간 변경 버튼 (픽업예상시간변경) "),
                                        (!_ctx.isHQ)
                                            ? (_openBlock(), _createBlock(_component_ChangePickupExpectedAtDialog, {
                                                key: 0,
                                                order: _ctx.order
                                            }, null, 8 /* PROPS */, ["order"]))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" 운행거리 "),
            (_ctx.policy.isDeliveryDistanceShow)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 8,
                    "no-gutters": "",
                    class: "mt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'distance')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular text-black" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.deliveryDistance), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" 대행료 "),
            (_ctx.policy.isDeliveryChargeShow)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 9,
                    "no-gutters": "",
                    class: "mt-4"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "pa-0 body2-text font-weight-regular brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'delivery_charge')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "8" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                    flat: "",
                                    tile: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_6, [
                                            _createVNode(_component_Chip, {
                                                "brg-chip-color": "blue",
                                                class: "mr-1",
                                                text: _ctx.deliveryPayType
                                            }, null, 8 /* PROPS */, ["text"]),
                                            _createCommentVNode(" 배달대행료 상세내역 + 툴팁 "),
                                            _createVNode(_component_OrderDetailDeliveryInfoBarogoTooltip, { order: _ctx.order }, null, 8 /* PROPS */, ["order"])
                                        ]),
                                        _createCommentVNode(" 대행료 변경 "),
                                        (_ctx.policy.isAdjustDeliveryAmountAvailable)
                                            ? (_openBlock(), _createBlock(_component_v_card_actions, {
                                                key: 0,
                                                class: "pt-3 pb-0 px-0"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_AdjustDeliveryAmountDialog, { order: _ctx.order }, {
                                                        activator: _withCtx((props) => [
                                                            _createCommentVNode(" 대행료 변경 버튼 "),
                                                            (!_ctx.isHQ && _ctx.isShowChangeDeliveryChargeBtn)
                                                                ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
                                                                    class: "btn-outlined-basic",
                                                                    variant: "outlined",
                                                                    width: "100%",
                                                                    height: "40"
                                                                }), {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'change_delivery_charge')), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
                                                                : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["order"])
                                                ]),
                                                _: 1 /* STABLE */
                                            }))
                                            : _createCommentVNode("v-if", true),
                                        _createCommentVNode(" 라이더 지원금 변경 "),
                                        (_ctx.isWorkerSupportAmountAvailable)
                                            ? (_openBlock(), _createBlock(_component_v_card_actions, {
                                                key: 1,
                                                class: "pt-3 pb-0 px-0"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_AddWorkerSupportAmountDialog, null, {
                                                        activator: _withCtx((props) => [
                                                            _createCommentVNode(" 라이더 지원금 변경 버튼 "),
                                                            (!_ctx.isHQ)
                                                                ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({ key: 0 }, props, {
                                                                    class: "btn-outlined-basic",
                                                                    variant: "outlined",
                                                                    width: "100%",
                                                                    height: "40"
                                                                }), {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'change_worker_support_amount')), 1 /* TEXT */)
                                                                    ]),
                                                                    _: 2 /* DYNAMIC */
                                                                }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
                                                                : _createCommentVNode("v-if", true)
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            }))
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }))
                : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
    }));
}
